import React from 'react';
import { styled } from "../stitches.config";
import Link from "../components/Link";
import { bodyLarge } from "./commonStyles/Fonts";

export const CtaGoogleNewsButton = () => {

    const buttonText = window.APP_SETTINGS.feature_flags_extended?.['CTAGoogleNewsButton'].extended_value?.['buttonText'];
    const buttonLink = window.APP_SETTINGS.feature_flags_extended?.['CTAGoogleNewsButton'].extended_value?.['buttonLink'];

    if (!buttonText || !buttonLink) {
        return null;
    }

    return (
        <StyledCtaButton className={bodyLarge()}>
            <Link data-analytics-name="article-cta-google-news-btn" to={buttonLink}>
                <StyledIcon src="https://m.natemat.pl/files/66/c4/66c4c9992f8f9dda0e7d6047bae0dd3c.svg" alt="" />
                {buttonText}
            </Link>
        </StyledCtaButton>
    )
};



const StyledCtaButton = styled('div', {
    "a": {
        width: "100%",
        margin: "0 auto 18px auto",
        color: "$grayscale100 !important",
        backgroundColor: "$grayscale0",
        border: "0px solid $primary",
        cursor: "pointer",
        padding: "7px 16px 9px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
})


const StyledIcon = styled('img', {
    marginRight: "16px",
    width: "20px",
    height: "20px",
    flexShrink: 0,
});


export default CtaGoogleNewsButton